import { render, staticRenderFns } from "./DetailTabBar.vue?vue&type=template&id=08308111&"
import script from "./DetailTabBar.vue?vue&type=script&lang=js&"
export * from "./DetailTabBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports